import type { ModuleDescriptorBase } from './module-descriptor';

import { chatDescriptor } from './modules/chat.descriptor';
import { expressDescriptor } from './modules/express.descriptor';

/**
 * Remote SDK modules — content-hashed bundles the loader dynamic-imports at
 * runtime from `config.moduleManifest`. Reserved for UI feature modules that
 * carry their own bundle (chat widget, express button).
 *
 * Capabilities (thin built-ins that ship inside `ekho.js`) live under
 * `../capabilities/` and are initialized inline by bootstrap — they do NOT
 * appear here. See `src/capabilities/README.md`.
 *
 * Adding a new remote module:
 *
 * 1. Create `modules/<name>.descriptor.ts` implementing `ModuleDescriptor<TApi>`
 * 2. Add one line here
 * 3. Extend `EkhoNamespace` in `types.ts` with the module's API type + `SdkModuleName`
 * 4. Add the module's config schema in `ekho-common/types/sdk/SdkConfig.ts`
 */
export const MODULE_REGISTRY: ModuleDescriptorBase[] = [chatDescriptor, expressDescriptor];
